import React from 'react';
import {  Navigate, Outlet } from 'react-router-dom';

import tokenService from '../../tools/tokenService';

const PrivateRedirect: React.FC = () => {
    return (
        tokenService.checkTokenDate() ? <Outlet /> : <Navigate to="/login" />
    )
}

export default PrivateRedirect;
